import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import UseMobile from "../../hooks/useIsMobile";
import { useHistory } from "react-router-dom";
import { openCommonPageModal } from "../../redux/action/utilActions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    // position: "relative",
    // // bottom: 0,
    // // left: 0,
    // // right: 0,
    // marginTop: "-10px",

    // clear: "both",
  },
  linksContainer: {
    height: "13vh",

    width: "100%",
    color: "white",
    [theme.breakpoints.down("md")]: {
      height: "auto",
      paddingBottom: theme.spacing(2),
    },
  },
  copyrightContainer: {
    height: "10vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    // backgroundColor: theme.palette.primary.dark,
    backgroundColor: "#1D364E",
    color: "white",
    [theme.breakpoints.down("md")]: {
      height: 70,
      padding: "6vh 0vw",
      width: "100%",

      // paddingBottom: theme.spacing(2),
    },
  },
  link: {
    fontSize: "1.2rem",
    textTransform: "uppercase",
    fontWeight: 500,
    color: "white",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      padding: 0,

      marginTop: theme.spacing(1),
    },
  },
  copyRight: {
    fontSize: "0.8rem",
    textTransform: "uppercase",
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
      textAlign: "center",
    },
  },
  socialItem: {
    cursor: "pointer",

    height: 50,
    width: 50,
    margin: theme.spacing(1),
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      height: 35,
      width: 35,
    },
  },
  socialContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      flexDirection: "column-reverse",
      justifyContent: "space-between",
    },
  },
  socialIconContainer: {
    display: "flex",
    alignItems: "center",

    flexDirection: "row",
    justifyContent: "flex-end",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",

      justifyContent: "flex-end",
    },
  },
  copyrightTextContainer: {
    flex: 1,
  },
}));

const Footer = ({ data }) => {
  // const isMobile = UseMobile();
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));
  const isTablet = useMediaQuery(theme.breakpoints.only("sm"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const renderBg = () => {
    if (isMobile) {
      return mobilebackgroundStyle;
    }
    if (isTablet) {
      return tabletbackgroundStyle;
    }
    if (isDesktop) {
      return backgroundStyle;
    }
  };
  const backgroundStyle = {
    backgroundImage: `url(${data.imageSrc})`,
    backgroundSize: `100% 100%`,
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: 300,
    backgroundColor: "#EDEDED",
  };

  const mobilebackgroundStyle = {
    backgroundImage: `url(${data.imageSrc})`,
    backgroundSize: `100% 100%`,
    backgroundColor: "#EDEDED",
    backgroundRepeat: "no-repeat",
    height: 100,
  };
  const tabletbackgroundStyle = {
    backgroundImage: `url(${data.imageSrc})`,
    backgroundSize: `100% 100%`,
    backgroundColor: "#EDEDED",
    backgroundRepeat: "no-repeat",
    height: 150,
  };
  const history = useHistory();

  const handleNavigate = (link, extenral, isModal, title) => {
    if (isModal) {
      return dispatch(openCommonPageModal({ title, link }));
    }
    if (extenral) {
      return window.open(link, "_blank");
    }
    if (link) {
      history.push(link);
    }
  };

  const renderTitle = (link) => {
    return link.title === "Visitors"
      ? `Visitors : ${data.visitors}`
      : link.title;
  };

  const renderSocialItem = (item, index) => {
    return (
      <img
        src={item?.icon}
        alt={index}
        className={classes.socialItem}
        key={index}
        onClick={() =>
          handleNavigate(item.link, item.external, item?.isModal, item?.title)
        }
      />
    );
  };
  return (
    <div className={classes.root}>
      <div className={classes.imgContainer} style={renderBg()} />

      <Container maxWidth="lg">
        <Grid
          container
          spacing={undefined}
          alignItems="center"
          justify="space-evenly"
          className={classes.linksContainer}
        >
          {data.data.map((link, index) => {
            return (
              <Grid item key={index} lg={3} md={3} sm={6} xs={6}>
                <Button
                  onClick={() =>
                    handleNavigate(
                      link.link,
                      link.external,
                      link?.isModal,
                      link?.title
                    )
                  }
                  className={classes.link}
                >
                  <Typography className={classes.link}>
                    {renderTitle(link)}
                  </Typography>
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </Container>
      <div className={classes.copyrightContainer}>
        <Container maxWidth="lg">
          <div className={classes.socialContainer}>
            <div className={classes.copyrightTextContainer}>
              <Typography className={classes.copyRight}>
                {data.copyright}
              </Typography>
            </div>
            <div className={classes.socialIconContainer}>
              {data?.social?.map((item, index) => {
                return renderSocialItem(item, index);
              })}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};
export default Footer;
